/** @ngInject */
export default function getFocusDirectiveConfig($timeout) {
    function link($scope, $element) {
        $scope.$watch('getFocus', (value) => {
            if (value) {
                $timeout(() => {
                    $element[0].focus();
                }, 1);
            }
        });
    }

    return {
        restrict: 'A',
        scope: {
            getFocus: '<'
        },
        link
    };
}



// WEBPACK FOOTER //
// ./app/common/get-focus/get-focus.directive.js